import React from 'react'
import { Link } from 'react-router-dom'
import { Calendar, Store, Monitor } from 'lucide-react'
import { useBranding } from '../context/BrandingContext'
import Button from './UI/Button'

const HeroPage = () => {
    const branding = useBranding()
    return (
        <div className="hero-container min-h-screen flex flex-col items-center justify-between sm:justify-center text-text">
            <header className="w-full max-w-3xl text-center mb-0 sm:mb-12">
                {/* Glow around title only (desktop & mobile) */}
                <div
                    className="w-full glowing-border hero"
                    style={{
                        "--border-width": "1px",
                        "--glow-size": "0.3rem",
                        "--glow-intensity": "0.15",
                        "--surface": "transparent",
                        padding: "0.5rem",
                    }}
                >
                    <h1 className="text-4xl sm:text-6xl font-extrabold text-white">
                        {branding?.heroWelcome || ''}
                    </h1>
                </div>
                {/* Subheader text */}
                <p className="text-lg sm:text-xl max-w-xl mx-auto text-gray-700 mt-4">
                    Promote your local event, showcase your business, or explore the happenings in our vibrant community.
                </p>
            </header>

            {/* Single responsive CTA row — stacks on mobile, row on sm+ */}
            <div className="flex flex-col sm:flex-row gap-4 mt-6">
                <Button as={Link} to="/login" variant="primary" size="lg">
                    Log In
                </Button>
                <Button as={Link} to="/register" variant="success" size="lg">
                    Register
                </Button>
            </div>

            {/* Feature strip */}
            <div className="flex flex-col sm:flex-row gap-6 mt-10 text-center">
                <div className="flex flex-col items-center gap-2">
                    <Calendar className="w-6 h-6 text-primary" />
                    <span className="text-sm font-medium text-gray-700">Submit Events</span>
                </div>
                <div className="flex flex-col items-center gap-2">
                    <Store className="w-6 h-6 text-primary" />
                    <span className="text-sm font-medium text-gray-700">Browse Businesses</span>
                </div>
                <div className="flex flex-col items-center gap-2">
                    <Monitor className="w-6 h-6 text-primary" />
                    <span className="text-sm font-medium text-gray-700">Digital Signage</span>
                </div>
            </div>
        </div>
    )
}

export default HeroPage
